/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Page SubscriberId routing
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.12.0
 */

import { Redirect, Route } from 'react-router';
import { Switch, useLocation, useParams } from 'react-router-dom';

import { CLIENT_ID, RoutePath } from '@routes/constants/routesConstants';
import type { IRouteParams } from '@routes/constants/routesConstants';

import SubscriberIdAdditionalAccounts from './components/AdditionalAccounts/components/SubscriberIdAdditionalAccounts';
import SubscriberIdDcRule from './components/DcRule/components/SubscriberIdDcRule';
import SubscriberIdFinances from './components/Finances/components/SubscriberIdFinances';
import SubscriberIdInfo from './components/Info/components/SubscriberIdInfo';
import SubscriberIdManageNumber from './components/ManageNumber/components/SubscriberIdManageNumber';
import PageSubscriberId from './components/PageSubscriberId';
import SubscriberIdPersonalData from './components/PersonalData/components/SubscriberIdPersonalData';
import SubscriberIdProducts from './components/Products/components/SubscriberIdProducts';

const PageSubscriberIdRoute = () => {
    const { clientId } = useParams<IRouteParams>();
    const { state } = useLocation<{ fromConstructor: boolean }>();

    return (
        <PageSubscriberId>
            <Switch>
                <Route
                    exact
                    component={SubscriberIdAdditionalAccounts}
                    path={RoutePath.subscriberIdAdditionalAccounts}
                />
                <Route
                    exact
                    component={SubscriberIdDcRule}
                    path={RoutePath.subscriberIdDcRule}
                />
                <Route
                    exact
                    component={SubscriberIdFinances}
                    path={RoutePath.subscriberIdFinances}
                />
                <Route
                    exact
                    component={SubscriberIdInfo}
                    path={RoutePath.subscriberIdInfo}
                />
                <Route
                    exact
                    component={SubscriberIdManageNumber}
                    path={RoutePath.subscriberIdManageNumber}
                />
                <Route
                    exact
                    component={SubscriberIdPersonalData}
                    path={RoutePath.subscriberIdPersonalData}
                />
                <Route
                    exact
                    component={SubscriberIdProducts}
                    path={RoutePath.subscriberIdProducts}
                />

                <Route exact path={RoutePath.subscriberId}>
                    <Redirect
                        to={{
                            pathname: RoutePath.subscriberIdInfo.replace(CLIENT_ID, clientId),
                            state,
                        }}
                    />
                </Route>
            </Switch>
        </PageSubscriberId>
    );
};

export default PageSubscriberIdRoute;
